import { UnitType } from '../ecclesiastical/unit-type.enum';
import { User } from './user.model';

export class Config {
  account_type: string;
  unitType?: UnitType;
  campusUnitId: number;
  user: User;
}
